<template>
  <div class="modal-aside-header">
    <h2 class="modal-aside-header__title">
      <slot />
    </h2>
    <DefButtonCross @click="modalAside.hide" />
  </div>
</template>

<script lang="ts" setup>
import useModalAside from '@use/useModalAside/useModalAside';
import DefButtonCross from '@components/Def/DefButtonCross/DefButtonCross.vue';

const modalAside = useModalAside();
</script>

<style lang="scss" scoped>
.modal-aside-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #cacece;
  flex: 0 0 auto;
  @include point-md {
    padding: 12px 24px;
  }
  &__title {
    color: #030304;
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 125%;
    text-transform: uppercase;
    @include point-md {
      font-size: 18px;
    }
  }
  :deep(.def-button-cross),
  :deep(.def-button-cross__icon) {
    width: 24px;
    height: 24px;
  }
}
</style>
